//© all rights reserved to 6over6 Ltd. 2022. This software (the "Software") is
the property of 6over6 Ltd. and its licensors. Any use of the Software is
strictly prohibited unless an explicit license or permission is granted by
6over6 Ltd.
<template>
  <section class="go_app_store_container">
    <a v-if="showMyRxApp" :href="branchUrl">
      <img
        src="https://assets.glasseson.com/web/images/luna/v1/myrx_icon_new.png"
      />
    </a>
    <a v-if="appStore === 'iphone'" :href="branchUrl">
      <img src="https://assets.glasseson.com/web/images/app_store_icon.png" />
    </a>
    <a v-if="appStore === 'android'" :href="branchUrl">
      <img src="https://assets.glasseson.com/web/images/play_store_icon.png" />
    </a>
  </section>
</template>

<script setup>
import Utils from "@/../../../common/services/Utils.js";
import { defineProps, computed } from "vue";

defineProps({
  branchUrl: {
    type: String,
    default: null,
  },
  showMyRxApp: {
    type: Boolean,
    default: false,
  },
});

const appStore = computed(() => {
  return Utils.getDeviceDetails().osName.toLowerCase();
});
</script>

<style lang="scss" scoped>
section.go_app_store_container {
  margin-top: 45px;
  text-align: center;

  a {
    cursor: pointer;
    margin-right: 25px;

    &:last-child {
      margin-right: 0;
    }

    img {
      height: 65px;
    }
  }
}
</style>
